import {LOGIN, SET_EMAIL} from "../mutations/auth";
import {logout} from "../../api/account";

const initialState = {
    api_key: null,
    language: null,
    email: '',
    iid: ''
};

const auth = {
    namespaced: true,
    state: initialState,
    getters: {
        authenticated: (state) => {
            return !!state.api_key;
        },
    },
    mutations: {
        [LOGIN](state, payload) {
            state.api_key = payload.user.api_key;
            state.language = payload.user.language;
            state.email = payload.user.email;
            state.iid = payload.user.iid;
        },
        [SET_EMAIL](state, payload) {
            state.email = payload.email;
        }
    },
    actions: {
        saveUserData({commit, state}, user) {
            commit({
                type: LOGIN,
                user: Object.assign({}, user, {
                    iid: 'web-' + Math.random().toString(36).substr(2, 11)
                }),
            })
        },
        removeUserData({commit, state, rootState, dispatch}) {
            logout(rootState.localization.language, {
                id_ristorante: rootState.restaurant.id,
                email: state.email,
                api_key: state.api_key,
                unique_id: state.iid
            }).then(() => {
                dispatch('order/setTimeLimit', {
                    limit: null
                }, {root: true});
                dispatch('order/resetTimers', null, {root: true});
                dispatch('global/showModalCartExpired', {
                    show: false,
                    error: ''
                }, {root: true});
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });

            commit({
                type: LOGIN,
                user: initialState,
            });
        },
        setEmail({commit, state}, email) {
            commit({
                type: SET_EMAIL,
                email
            });
        }
    }
};
export default auth;
